import { Loader } from 'components/Loader';

import { useList } from './List.hooks';
import * as S from './List.styles';
import { Inputs } from './components/Inputs';
import { Products } from './components/Products';

export function List(): React.ReactElement {
  const { products, control, watch, season, zone, isLoading } = useList();

  return (
    <S.Container>
      <Inputs control={control} watch={watch} />

      <Loader isLoading={isLoading}>
        {products && products.length > 0 ? (
          <Products season={season} zone={zone} products={products} />
        ) : undefined}
      </Loader>
    </S.Container>
  );
}
